import React, { useEffect } from "react";

const AdBanner = () => {
    useEffect(() => {
        // 애드센스 스크립트 실행
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
            console.error("Adsense error:", e);
        }
    }, []);

    return (
        <div>
            <ins
                className="adsbygoogle"
                style={{ display: "block", textAlign: "center" }}
                data-ad-client="ca-pub-8279797499804816" // 애드센스 클라이언트 ID
                data-ad-slot="8972256470" // 광고 슬롯 ID
                data-ad-format="auto"
                // data-ad-test="on" // 테스트 광고 활성화
                data-full-width-responsive="true"
            ></ins>
        </div>
    );
};

export default AdBanner;
